import type { PGlite } from "@electric-sql/pglite";

const seedDatabase = `
      DROP TABLE IF EXISTS orders;
      DROP TABLE IF EXISTS products;
      DROP TABLE IF EXISTS users;

      CREATE TABLE users (
        id SERIAL PRIMARY KEY,
        name TEXT NOT NULL,
        email TEXT UNIQUE NOT NULL,
        created_at TIMESTAMP DEFAULT NOW()
      );

      CREATE TABLE products (
        id SERIAL PRIMARY KEY,
        name TEXT NOT NULL,
        price DECIMAL(10, 2) NOT NULL,
        stock INTEGER DEFAULT 0
      );

      CREATE TABLE orders (
        id SERIAL PRIMARY KEY,
        user_id INTEGER REFERENCES users(id),
        total DECIMAL(10, 2) NOT NULL,
        status TEXT DEFAULT 'pending',
        created_at TIMESTAMP DEFAULT NOW()
      );

      INSERT INTO users (name, email) VALUES
        ('Alice Johnson', 'alice@example.com'),
        ('Bob Smith', 'bob@example.com'),
        ('Charlie Brown', 'charlie@example.com'),
        ('Diana Prince', 'diana@example.com'),
        ('Evan Wright', 'evan@example.com');

      INSERT INTO products (name, price, stock) VALUES
        ('Laptop', 999.99, 50),
        ('Mouse', 25.50, 200),
        ('Keyboard', 59.99, 150),
        ('Monitor', 199.99, 80),
        ('Headphones', 49.99, 100);

      INSERT INTO orders (user_id, total, status) VALUES
        (1, 1025.49, 'completed'),
        (2, 59.99, 'pending'),
        (3, 199.99, 'shipped'),
        (1, 25.50, 'completed'),
        (4, 49.99, 'processing');
    `
export { seedDatabase };
